import { provideNgxMask } from 'ngx-mask';
import {
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  LOCALE_ID,
} from '@angular/core';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AuthInterceptor } from '../shared/interceptors/auth-interceptor';
import { StatusErrorInterceptor } from '../shared/interceptors/status-error-interceptor';
import { providePrimeNG } from 'primeng/config';
import { provideToastr } from 'ngx-toastr';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withNavigationErrorHandler,
} from '@angular/router';
import { recoverFromChunkLoadError } from '../shared/helpers/chunk-load-recovery.helper';
import { appRoutes } from '../app-routing.module';
import { DatePipe, DecimalPipe } from '@angular/common';
import { CustomDateAdapter } from './date-adapter.config';
import { primeNgConfig } from '../@theme/styles/primeng-config/primeng.config';

export const appConfig: ApplicationConfig = {
  providers: [
    DatePipe,
    DecimalPipe,
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    { provide: LOCALE_ID, useValue: 'pt' },
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'DD/MM/yyyy',
        },
        display: {
          dateInput: 'DD/MM/yyyy',
          monthYearLabel: 'MMM yyyy',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM yyyy',
        },
      },
    },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: StatusErrorInterceptor,
      multi: true,
    },
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
      withEnabledBlockingInitialNavigation(),
      withNavigationErrorHandler(recoverFromChunkLoadError)
    ),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    provideNgxMask(),
    provideToastr(),
    providePrimeNG(primeNgConfig),
  ],
};
